<template>
  <div class="warranty">
    <Loader
      v-if="loaderEnabled"
      :logo="loaderLogo"
    ></Loader>
    <KTCodePreview v-bind:title="title">
      <template v-slot:toolbar>
        <div class="row">
          <div class="ml-3">
            <router-link
              :to="addNewRoute"
              v-if="showAddButton"
            >
              <button
                type="button"
                class="btn btn-primary font-weight-bolder btn-sm"
              >
                <i
                  style="font-size: 1rem"
                  class="flaticon2-add-1"
                ></i
                >Thêm mới
              </button>
            </router-link>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <WarrantySearchBar
          :params="apiParams"
          :page-size="selectedPageSize"
          :status-options="statusOptions"
          :option-stores="optionStores"
          :all-option-stores="allOptionStores"
          :option-page-size="optionPageSize"
          :is-loading="isLoading"
          :warranty-service-options="warrantyServiceOptions"
          :list-company="listCompany"
          @filter="onFilter"
          @reset="onReset"
          @page-size-change="onPageSizeChange"
        />
        <WarrantyListTable
          detail-mode="reception"
          :items="listItem"
          :fields="fields"
          :is-loading="isLoading"
          :total-items="totalItems"
          :number-of-page="numberOfPage"
          :current-page="currentPage"
          :limit="limit"
          :can-create-lending-stock-slip="checkPermission('WARRANTY_RECEPTION_UPDATE')"
          :can-edit="checkPermission('WARRANTY_RECEPTION_UPDATE')"
          :can-delete="checkPermission('WARRANTY_RECEPTION_DELETE')"
          :can-print="true"
          :can-change-store="checkPermission('WARRANTY_RECEPTION_UPDATE')"
          :can-complete="checkPermission('WARRANTY_COMPLETED')"
          :current-store-id="currentStoreId"
          :can-return="checkPermission('WARRANTY_RECEPTION_UPDATE')"
          :can-update-unlimit="checkPermission('WARRANTY_UPDATE_UNLIMIT')"
          @edit="editItem"
          @view-detail="viewWarrantyDetail"
          @delete="onDeleteItem"
          @print="printItem"
          @page-change="onPageChange"
          @create-lending-stock-slip="onCreateLendingStockSlip"
          @change-store="onOpenChangeStore"
          @confirm-transfer="onConfirmTransfer"
          @complete-warranty="onCompleteWarranty"
          @return-warranty="onReturnWarranty"
        />
      </template>
    </KTCodePreview>

    <WarrantyChangeStoreModal
      v-model="showChangeStoreModal"
      :warranty="changeStoreWarranty"
      :option-stores="allOptionStores"
      :busy="isChangingStore"
      @save="onSaveChangeStore"
      @hidden="changeStoreWarranty = null"
    />
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue'
import { SET_BREADCRUMB } from '@/core/services/store//modules/breadcrumbs.module'
import { showDeleteAlert } from '@/utils/sweet-alert2'
import { mapGetters } from 'vuex'
import Loader from '@/view/content/Loader.vue'
import permissionMixin from '@/view/mixins/permission.mixin'
import { formatDBDate } from '@/utils/date'
import {
  getWarrantyReceptions,
  deleteWarrantyReception,
  changeWarrantyStore,
  confirmWarrantyTransfer,
  bulkUpdateWarrantyStatus,
  getWarrantyServices,
} from './utils/warrantyApi'
import { mapWarrantyListItem } from './utils/listHelpers'
import WarrantySearchBar from './components/WarrantySearchBar.vue'
import WarrantyListTable from './components/WarrantyListTable.vue'
import WarrantyChangeStoreModal from './components/WarrantyChangeStoreModal.vue'
import apiCommonMixin from '@/view/mixins/api-common.mixins'
import { handleError, makeToastFaile, makeToastSuccess } from '@/utils/common'
import { WARRANTY_RECEPTION_STATUS, PAGE_ACTION } from '@/utils/enum'

export default {
  mixins: [permissionMixin, apiCommonMixin],
  props: {
    forceStatus: {
      type: String,
      default: null,
    },
    titleOverride: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      modalDesc: 'Bạn có chắc xoá bản ghi',
      modalTitle: 'Xoá ',
      apiParams: {
        code: null,
        imeiCode: null,
        customerPhone: null,
        customerName: null,
        startDate: null,
        endDate: null,
        status: [],
        storeIds: [],
        previousStoreIds: [],
        criteriaIds: [],
        transferStatus: [],
        productName: null,
        primaryTechnicianId: null,
        inspectedByEmployeeId: null,
        warrantyServiceId: null,
        companyId: null,
        creditUnitIds: [],
        paymentCode: null,
      },
      allOptionStores: [],
      listCompany: [],
      listItem: [],
      numberOfPage: 1,
      totalItems: 0,
      selectedPageSize: null,
      limit: 10,
      optionPageSize: [10, 25, 50, 100],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '5%' },
        },
        { key: 'imeiCode', label: 'Sản phẩm', sortable: false, thStyle: { width: '15%' } },
        { key: 'customerPhone', label: 'Khách hàng', sortable: false },
        {
          key: 'statusName',
          label: 'Trạng thái',
          sortable: false,
          tdClass: 'text-center',
          thStyle: { width: '10%' },
        },
        {
          key: 'info',
          label: 'Thông tin',
          sortable: false,
          thStyle: { width: '20%' },
        },
        {
          key: 'note',
          label: 'Ghi chú',
          sortable: false,
          thClass: 'note-cell',
          thStyle: { width: '15%' },
        },
        { key: 'storeName', label: 'Tại', sortable: false },
        {
          key: 'paymentStatus',
          label: 'Thanh toán',
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: { width: '12%' },
        },
        { key: 'actions', label: '', sortable: false, thStyle: { width: '5%' } },
      ],
      statusOptions: [
        { id: 'RECEIVING', name: 'Đang tiếp nhận' },
        { id: 'REPAIRING', name: 'Đang sửa' },
        { id: 'REPAIRED', name: 'Đã sửa' },
        { id: 'COMPLETED', name: 'Hoàn thành' },
        { id: 'RETURNED', name: 'Đã trả' },
        { id: 'REJECTED', name: 'Đã từ chối' },
      ],
      isLoading: false,
      warrantyServiceOptions: [],
      showChangeStoreModal: false,
      changeStoreWarranty: null,
      optionStores: [],
      isChangingStore: false,
      currentStoreId: null,
    }
  },
  components: {
    KTCodePreview,
    Loader,
    WarrantySearchBar,
    WarrantyListTable,
    WarrantyChangeStoreModal,
  },
  computed: {
    ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'))
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo')
    },
    currentPage() {
      return Number(this.$route.query.page) || 1
    },
    addNewRoute() {
      return '/warranty-receptions/info'
    },
    title() {
      return this.titleOverride || 'Danh sách Tiếp nhận'
    },
    showAddButton() {
      return this.checkPermission('WARRANTY_RECEPTION_INSERT')
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.title }])
  },
  watch: {},
  beforeRouteLeave(to, _from, next) {
    if (to.name === 'warranty-reception-info') {
      sessionStorage.setItem(
        'warranty-reception-filter',
        JSON.stringify({ apiParams: this.apiParams, limit: this.limit }),
      )
    }
    next()
  },
  async created() {
    try {
      const [{ stores, currentStoreId, currentStoreName, currentStoreShortName }, warrantyServices, companies] =
        await Promise.all([this.fetchStoreByUser(), getWarrantyServices(), this.fetchCompanies()])
      this.warrantyServiceOptions = warrantyServices
      this.listCompany = [{ id: null, name: 'Tất cả doanh nghiệp' }, ...companies]
      this.currentStoreId = currentStoreId
      this.optionStores = this.mapDataTreeSelect(stores || [], ['id', 'name', 'shortName'])
      if (currentStoreId) {
        this.apiParams.storeIds = [
          {
            id: currentStoreId,
            name: currentStoreName || '',
            shortName: currentStoreShortName || currentStoreName || '',
          },
        ]
      }
      const { data: allStores } = await this.fetchStores()
      this.allOptionStores = this.mapDataTreeSelect(allStores || [], ['id', 'name', 'shortName'])
    } catch (e) {
      this.optionStores = []
      this.allOptionStores = []
      handleError(e)
    }
    const saved = sessionStorage.getItem('warranty-reception-filter')
    if (saved) {
      try {
        const { apiParams, limit } = JSON.parse(saved)
        if (apiParams) this.apiParams = apiParams
        if (limit) { this.limit = limit; this.selectedPageSize = limit }
      } catch {}
      sessionStorage.removeItem('warranty-reception-filter')
    }
    this.fetchData()
  },
  methods: {
    showDeleteAlert,
    onFilter(params) {
      this.apiParams = { ...params }
      this.$route.query.page = 1
      this.$router.push({
        name: this.$route.name,
      })
      this.fetchData()
    },
    onReset(params) {
      this.apiParams = { ...params }
      this.selectedPageSize = null
      this.limit = 10
      this.fetchData()
    },
    onPageSizeChange(newSize) {
      this.selectedPageSize = newSize
      this.limit = newSize || 10
      this.fetchData()
    },
    onPageChange(page) {
      this.$router.push({
        name: this.$route.name,
        query: { ...this.$route.query, page },
      })
      this.fetchData()
    },
    editItem(item) {
      this.$router.push({
        name: 'warranty-reception-info',
        query: { id: item.id, action: PAGE_ACTION.UPDATE },
      })
    },
    viewWarrantyDetail(item) {
      if (!item?.id) return
      this.$router.push({
        name: 'warranty-reception-info',
        query: { id: item.id, action: 'view' },
      })
    },
    onDeleteItem(item) {
      showDeleteAlert(
        this.modalTitle,
        `${this.modalDesc} ${item.code || item.id}`,
        item,
        this.confirmDeleteItem,
      )
    },
    getParamFilters() {
      return {
        page: this.$route.query.page || 1,
        limit: this.limit,
        id: this.apiParams.id,
        code: this.apiParams.code,
        imeiCode: this.apiParams.imeiCode && this.apiParams.imeiCode.trim(),
        customerPhone: this.apiParams.customerPhone && this.apiParams.customerPhone.trim(),
        customerName: this.apiParams.customerName && this.apiParams.customerName.trim(),
        startDate: formatDBDate(this.apiParams.startDate),
        endDate: formatDBDate(this.apiParams.endDate),
        status: this.forceStatus || this.apiParams.status,
        storeIds: (this.apiParams.storeIds || []).map((s) => s.id),
        previousStoreIds: (this.apiParams.previousStoreIds || []).map((s) => s.id),
        mode: 'reception',
        criteriaIds: (this.apiParams.criteriaIds || []).map((s) => s.id),
        transferStatus: (this.apiParams.transferStatus || []).map((s) => s.id),
        productName: this.apiParams.productName || null,
        primaryTechnicianId: this.apiParams.primaryTechnicianId || null,
        inspectedByEmployeeId: this.apiParams.inspectedByEmployeeId || null,
        warrantyServiceId: this.apiParams.warrantyServiceId || null,
        companyId: this.apiParams.companyId || null,
        creditUnitIds: (this.apiParams.creditUnitIds || []).map((u) => u.id),
        paymentCode: this.apiParams.paymentCode || null,
      }
    },
    async fetchData() {
      if (this.isLoading) return

      this.isLoading = true
      this.page = this.$route.query.page || 1

      try {
        const params = this.getParamFilters()
        const dataset = await getWarrantyReceptions(params)

        this.totalItems = dataset.totalRow || 0
        this.numberOfPage = dataset.totalPage || 1
        this.listItem = (dataset.dataset || []).map((item) => mapWarrantyListItem(item))
      } catch (error) {
        console.error('Error fetching data:', error)
        this.totalItems = 0
        this.numberOfPage = 1
        this.listItem = []
      } finally {
        this.isLoading = false
      }
    },
    async deleteItem(id) {
      const success = await deleteWarrantyReception(id)
      if (success) {
        this.fetchData()
      }
    },
    confirmDeleteItem(item) {
      this.deleteItem(item.id)
    },
    printItem(item) {
      this.$router.push({
        name: 'print-warranty-reception',
        query: { id: item.id },
      })
    },
    onCreateLendingStockSlip(item) {
      if (!item?.id) return
      this.$router
        .push({
          name: 'add-lending-stockslip',
          query: { billId: item.id },
        })
        .catch(() => {})
    },
    async onOpenChangeStore(item) {
      this.changeStoreWarranty = item
      this.showChangeStoreModal = true
    },
    mapDataTreeSelect(items = [], keys = ['id', 'name', 'shortName']) {
      if (!items || !items.length) return []
      const [idKey, nameKey, shortNameKey] = keys
      const label = (item) => item[nameKey] || item[shortNameKey] || ''
      const short = (item) => item[shortNameKey] || item[nameKey] || ''
      return items.map((item) => ({
        id: item[idKey],
        name: label(item),
        label: label(item),
        shortName: short(item),
      }))
    },
    async onSaveChangeStore({ warrantyId, storeId }) {
      if (!warrantyId || !storeId) return
      this.isChangingStore = true
      try {
        await changeWarrantyStore(warrantyId, storeId)
        this.showChangeStoreModal = false
        this.fetchData()
      } catch (e) {
        // handleError already called in API
      } finally {
        this.isChangingStore = false
      }
    },
    async onConfirmTransfer(item) {
      if (!item || (!item.id && !item.warrantyId)) return
      const id = item.id || item.warrantyId

      const h = this.$createElement
      const messageVNode = h('div', {
        domProps: {
          innerHTML: `Bạn có chắc chắn đã nhận IMEI <strong>${item.imeiCode}</strong> của phiếu bảo hành #${id} không?`,
        },
      })
      const isConfirm = await this.$bvModal.msgBoxConfirm(messageVNode, {
        title: 'Xác nhận nhận máy',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Đồng ý',
        cancelTitle: 'Hủy',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })

      if (!isConfirm) return

      try {
        await confirmWarrantyTransfer(id)
        this.fetchData()
      } catch (err) {
        // handled in API
      }
    },
    async onCompleteWarranty(item) {
      if (!item || !item.id) return
      try {
        const payload = {
          warranties: [{ id: item.id, status: WARRANTY_RECEPTION_STATUS.COMPLETED }],
        }
        const results = await bulkUpdateWarrantyStatus(payload)
        const result = Array.isArray(results) ? results.find((r) => r.id === item.id) : null
        if (result && result.isError) {
          makeToastFaile(result.message || 'Cập nhật thất bại')
        } else {
          makeToastSuccess('Hoàn thành phiếu bảo hành thành công')
          this.fetchData()
        }
      } catch (err) {
        makeToastFaile('Lỗi khi hoàn tất phiếu')
      }
    },
    async onReturnWarranty(item) {
      if (!item || !item.id) return
      try {
        const payload = {
          warranties: [{ id: item.id, status: WARRANTY_RECEPTION_STATUS.RETURNED }],
        }
        const results = await bulkUpdateWarrantyStatus(payload)
        const result = Array.isArray(results) ? results.find((r) => r.id === item.id) : null
        if (result && result.isError) {
          makeToastFaile(result.message || 'Cập nhật thất bại')
        } else {
          makeToastSuccess('Trả bảo hành thành công')
          this.fetchData()
        }
      } catch (err) {
        makeToastFaile('Lỗi khi trả phiếu bảo hành')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.warranty {
  .icon:hover {
    background-color: #90c6fc;
  }

  .bootstrap-datetimepicker-widget.dropdown-menu {
    width: 21em;
  }
}
</style>
